import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collectRespFormErrors } from "utils/functions";
import Toast from "utils/Toast";

interface useEndRequestProps<D, I> {
	APIMethod?: ( data: D ) => Promise<I>;
	success_message?: string;
	error_message?: string;
   redirect_to?: string | (( item: I ) => string );
	onSuccess?: ( response: I ) => void;
	onError?: ( err: unknown ) => void;
   setErrors?: ( err: FDataErrors ) => void;
}

export default function useSendRequest<D, I>({
	APIMethod,
	success_message,
	error_message,
   redirect_to,
	onSuccess,
	onError,
   setErrors
}: useEndRequestProps<D, I>) {

   const navigate = useNavigate();
	const [ querying, setQuerying ] = useState( false );

	const sendRequest = useCallback( async( data: D ) => {

		if ( !APIMethod || querying ) return;
		setQuerying( true );

		try {
			const resp = await APIMethod( data );
			
			success_message && Toast.success( success_message );
			onSuccess && onSuccess( resp );

         if ( redirect_to ) {
            setTimeout(() => {
               typeof redirect_to === "string" 
                  ? navigate( redirect_to )
                  : navigate( redirect_to?.( resp ))
            }, 200 )
         }

		} catch ( err: any ) {

			const be_message = err?.response?.data?.message;
			be_message && Toast.error( be_message );

			!be_message && error_message && Toast.error( error_message );
			onError && onError( err );

         setErrors && setErrors( collectRespFormErrors( err ));
			throw err;

		} finally {
			setQuerying( false );
		}
	}, [ querying ])

	return { 
		querying,
		sendRequest
	}
}  